export default (params, prefix) => {
	let urlString = '';

	// Alphabetizes the keys to keep url in alphabetical order
	const sortedParams = Object.keys(params)
		.sort()
		.reduce(
			(acc, key) => ({
				...acc,
				[key]: params[key],
			}),
			{},
		);

	// Loops through sorted params object to build url
	Object.keys(sortedParams).forEach((key) => {
		const value = sortedParams[key];

		// Skip page=1 so first page URLs are canonical without querystring
		if (key === 'page' && (value === 1 || value === '1')) {
			return; // do not append
		}

		// Handle arrays - filter to non-empty strings first
		if (Array.isArray(value)) {
			const items = value.filter(
				(v) => typeof v === 'string' && v.length > 0,
			);

			// Skip empty arrays entirely to avoid appending "amenities=" with no value
			if (items.length === 0) {
				return;
			}

			// Single-item arrays use bracket notation so parsers treat them as arrays
			if (items.length === 1) {
				const pair = `${key}[]=${encodeURIComponent(items[0])}`;
				urlString = urlString === '' ? pair : `${urlString}&${pair}`;
				return;
			}

			// Multiple items: create key=value pairs joined by &
			const arrayQueryString = items
				.map((item) => `${key}=${encodeURIComponent(item)}`)
				.join('&');

			urlString =
				urlString === ''
					? arrayQueryString
					: `${urlString}&${arrayQueryString}`;
			return;
		}

		// Prevents appending null/undefined values
		if (value) {
			if (urlString !== '') {
				urlString += '&';
			}
			urlString += `${key}=${encodeURIComponent(value)}`;
		}
	});

	return `${prefix ? '/search' : ''}?${urlString}`;
};
